import { chainConfig } from '../../tempo/chainConfig.js';
import { defineChain } from '../../utils/chain/defineChain.js';
export const tempo = /*#__PURE__*/ defineChain({
    ...chainConfig,
    id: 4217,
    blockExplorers: {
        default: {
            name: 'Tempo Explorer',
            url: 'https://explore.mainnet.tempo.xyz',
        },
    },
    name: 'Tempo Mainnet',
    nativeCurrency: {
        name: 'USD',
        symbol: 'USD',
        decimals: 6,
    },
    rpcUrls: {
        default: {
            http: ['https://rpc.presto.tempo.xyz'],
            webSocket: ['wss://rpc.presto.tempo.xyz'],
        },
    },
});
//# sourceMappingURL=tempo.js.map